<div class="quick-top-up-page page-section">
    <div class="header-part">
        <h1>Quick Top-Up</h1>
    </div>
    <div class="info-banner success">
        <div class="flex">
            <img src="assets/icon/banner-success-icon.svg" width="32" height="32" alt="Success Icon">
            <div class="banner-content">
                <p class="smaller desc-a">Funds have been successfully added to your account.</p>
                <p class="smaller desc-b last">Mobile number: <b>{{phoneNumber}}</b></p>
            </div>
        </div>
    </div>
    <div class="action">
        <button class="button primary" id="done-button" (click)="done()">Done</button>
    </div>
</div>